import React, {Component} from "react";
import {Route, Router, Switch,} from "react-router-dom";
import {createBrowserHistory} from 'history';
import {SunIcon, MoonIcon, MenuIcon, XIcon} from '@heroicons/react/outline';
import App from "../app/app";
import Landing from "../landing/landing";


import "./router.scss"
import {JobsPage} from '../job/job';
import AboutPage from '../about/about';
import TermsAndConditionsPage from '../terms-conditions/terms-conditions';
import ContactPage from '../contact/contact';

import translationInit from "../../language";
import i18next from "i18next";
import Cookie from '../cookie-acceptance/cookie';
import BackToTopBtn from '../back-to-top/BackToTopBtn';
import { trackRouteView } from "../../analytics";

export const history = createBrowserHistory({basename: "/"});
history.listen((location) => {
	window.scrollTo(0, 0);
	trackRouteView("app-home", `${location.pathname}${location.search}${location.hash}`);
});

export default class Routes extends Component {

	unlisten: any = null;

	state = {
		page: history.location.pathname.split("/").pop(),
		pathname: history.location.pathname,
		language: "en",
		isLangOpen: false,
		isMobileMenuOpen: false,
		isDarkMode: window.matchMedia('(prefers-color-scheme: dark)').matches || localStorage.getItem('darkMode') === "true",
	};

	handleChange = (e:any) => {
		this.setState({isDarkMode: e.matches});
	};

	navigate = (page: string) => (e: any) => {
		e.preventDefault();
		this.setState({page});
		history.push("/" + page);
		return false;
	};

	redirectGetStarted = (url: string) => {
		window.location.href = "/" + url
	};

	toggleDarkMode = () => {
		this.setState({isDarkMode: !this.state.isDarkMode}, () => {
			const newDarkModeState = this.state.isDarkMode;
			if (newDarkModeState) {
				document.documentElement.classList.add('dark');
			} else {
				document.documentElement.classList.remove('dark');
			}
			localStorage.setItem("darkMode", newDarkModeState.toString());
		});
	};

	toggleMobileMenu = () => {
		this.setState({isMobileMenuOpen: !this.state.isMobileMenuOpen});
	};

	changeLanguage(lang: string) {
		return async () => {
			await i18next.changeLanguage(lang).then(r => {console.log(r)});
			this.setState({...this.state, language: lang});
			window.localStorage.i18nextLng = lang;
		}
	}

	componentDidMount() {
		const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
		// Listen for changes to the system preference
		mediaQuery.addEventListener('change', this.handleChange);
		trackRouteView("app-home", `${history.location.pathname}${history.location.search}${history.location.hash}`);
		if (this.state.isDarkMode) {
			document.documentElement.classList.add('dark');
		} else {
			document.documentElement.classList.remove('dark');
		}
		localStorage.setItem('darkMode', this.state.isDarkMode.toString());
		// Keep `pathname` in state so the landing/non-landing chrome switches on navigation.
		this.unlisten = history.listen((location) => {
			this.setState({pathname: location.pathname});
		});
	}

	componentWillUnmount() {
		if (this.unlisten) this.unlisten();
	}

	componentWillMount(): void {
		translationInit().then(async () => {
			await i18next.changeLanguage(window.localStorage.i18nextLng || navigator.language.split("-")[0]).then(r => {
			});
			this.setState({...this.state, language: window.localStorage.i18nextLng || navigator.language.split("-")[0]});
			console.log('Translation successfully Initialized...');
		});
	}

	render() {

		const {page} = this.state;

		// The new-ui landing renders its own Nav + footer, so it bypasses the legacy
		// app-home header/footer chrome. Everything that isn't an explicit marketing
		// sub-route is treated as the landing (matches the old `*` -> landing fallback).
		const NON_LANDING = ['/about', '/contact', '/jobs', '/careers', '/job', '/hiring', '/terms', '/terms-and-conditions'];
		const isLanding = !NON_LANDING.some(p => this.state.pathname === p || this.state.pathname.startsWith(p + '/'));

		if (isLanding) {
			const landingProps = {
				signUp: this.redirectGetStarted,
				language: this.state.language,
				onChangeLanguage: (l: string) => this.changeLanguage(l)(),
				history,
			};
			return (
				<Router history={history}>
					<Switch>
						<Route path="/home"> <Landing {...landingProps}/> </Route>
						<Route path="/"> <Landing {...landingProps}/> </Route>
						<Route path="*"> <Landing {...landingProps}/> </Route>
					</Switch>
					<Cookie/>
					<BackToTopBtn/>
				</Router>
			);
		}

		return (
			<Router history={history}>
				<header className="bg-white z-[100] dark:!bg-gray-900 shadow-md">
					<div className="container relative mx-auto flex w-full justify-between items-center p-4">
						<div
							className="flex justify-start items-start relative overflow-hidden gap-2.5 py-2.5">
							<div className="flex-grow-0 flex-shrink-0 w-[251.46px] h-9">
								<svg
									width={6}
									height={6}
									viewBox="0 0 6 6"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[31.79px] top-[23.99px]"
									preserveAspectRatio="none"
								>
									<path
										d="M2.83133 0.487305C3.33458 0.487305 3.82656 0.636534 4.24499 0.916122C4.66343 1.19571 4.98956 1.5931 5.18214 2.05804C5.37472 2.52298 5.42508 3.03459 5.3269 3.52817C5.22872 4.02174 4.98642 4.47511 4.63058 4.83096C4.27473 5.1868 3.82131 5.42915 3.32773 5.52733C2.83416 5.62551 2.32258 5.57512 1.85765 5.38254C1.39271 5.18995 0.995314 4.86382 0.715726 4.44539C0.436138 4.02696 0.286926 3.53501 0.286926 3.03176C0.286926 2.35693 0.554983 1.70973 1.03216 1.23256C1.50934 0.755379 2.1565 0.487305 2.83133 0.487305ZM3.90558 3.22635C3.95786 3.19559 3.99589 3.14544 4.01141 3.08681C4.02693 3.02817 4.01865 2.96578 3.98843 2.91318C3.97043 2.87736 3.9414 2.84828 3.90558 2.83028L2.65404 2.10379C2.6274 2.08815 2.59787 2.07803 2.56725 2.07403C2.53663 2.07003 2.50551 2.07224 2.47576 2.08051C2.446 2.08878 2.41827 2.10295 2.3941 2.12218C2.36994 2.14141 2.34989 2.1653 2.33514 2.19244C2.3166 2.22806 2.30636 2.26743 2.30521 2.30758V3.75365C2.3052 3.78438 2.31134 3.81481 2.32327 3.84312C2.3352 3.87144 2.35264 3.89708 2.37464 3.91854C2.39663 3.94 2.4227 3.95684 2.4513 3.96807C2.47991 3.9793 2.51046 3.98468 2.54118 3.98391C2.58143 3.98349 2.621 3.97321 2.65636 3.95398L3.90558 3.22635Z"
										fill="#7AC144"
									/>
								</svg>
								<svg
									width={3}
									height={4}
									viewBox="0 0 3 4"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[32.76px] top-[30.19px]"
									preserveAspectRatio="none"
								>
									<path
										d="M1.50667 3.18387C2.19468 3.18387 2.75242 2.62613 2.75242 1.93813C2.75242 1.25012 2.19468 0.692383 1.50667 0.692383C0.818664 0.692383 0.260925 1.25012 0.260925 1.93813C0.260925 2.62613 0.818664 3.18387 1.50667 3.18387Z"
										fill="#2AAAE1"
									/>
								</svg>
								<svg
									width={2}
									height={2}
									viewBox="0 0 2 2"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[32.89px] top-[19.64px]"
									preserveAspectRatio="none"
								>
									<path
										d="M1.0646 1.50018C1.43976 1.50018 1.74389 1.19605 1.74389 0.82089C1.74389 0.445729 1.43976 0.141602 1.0646 0.141602C0.689443 0.141602 0.385315 0.445729 0.385315 0.82089C0.385315 1.19605 0.689443 1.50018 1.0646 1.50018Z"
										fill="#2AAAE1"
									/>
								</svg>
								<svg
									width={4}
									height={4}
									viewBox="0 0 4 4"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[30.46px] top-[21.2px]"
									preserveAspectRatio="none"
								>
									<path
										d="M2.28694 3.34108C3.01754 3.34108 3.60982 2.74881 3.60982 2.0182C3.60982 1.28759 3.01754 0.695312 2.28694 0.695312C1.55633 0.695312 0.96405 1.28759 0.96405 2.0182C0.96405 2.74881 1.55633 3.34108 2.28694 3.34108Z"
										fill="#2AAAE1"
									/>
								</svg>
								<svg
									width={15}
									height={14}
									viewBox="0 0 15 14"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[17.56px] top-[25.88px]"
									preserveAspectRatio="none"
								>
									<path
										d="M8.21129 0.381836C9.24135 0.382679 10.2567 0.626787 11.1745 1.09429C12.0924 1.56179 12.8869 2.23947 13.4932 3.07213C14.0996 3.90479 14.5008 4.86888 14.664 5.88592C14.8273 6.90296 14.748 7.94419 14.4327 8.9248C14.1174 9.90541 13.5749 10.7977 12.8495 11.529C12.1241 12.2603 11.2362 12.8099 10.2581 13.133C9.28006 13.4562 8.23951 13.5438 7.2212 13.3888C6.20288 13.2337 5.23559 12.8403 4.39809 12.2406L0.0644531 11.9988L1.97107 8.89022C1.66162 7.91023 1.58752 6.87106 1.75481 5.85708C1.9221 4.84309 2.32606 3.88283 2.9339 3.05417C3.54174 2.22551 4.33634 1.55182 5.25326 1.08772C6.17019 0.623611 7.1836 0.382169 8.21129 0.382995V0.381836ZM12.0844 6.92257C12.0844 6.72765 12.0266 6.53712 11.9183 6.37505C11.81 6.21298 11.6561 6.08665 11.476 6.01206C11.2959 5.93747 11.0978 5.91796 10.9066 5.95598C10.7154 5.99401 10.5398 6.08786 10.402 6.22569C10.2642 6.36352 10.1703 6.53913 10.1322 6.73031C10.0942 6.92149 10.1137 7.11964 10.1883 7.29972C10.2629 7.47981 10.3892 7.63372 10.5513 7.74202C10.7134 7.85031 10.904 7.9081 11.0989 7.9081C11.3601 7.90749 11.6104 7.80349 11.7951 7.61879C11.9798 7.4341 12.0838 7.18377 12.0844 6.92257ZM9.19802 6.92257C9.19802 6.72765 9.14019 6.53712 9.03189 6.37505C8.9236 6.21298 8.76969 6.08665 8.5896 6.01206C8.40952 5.93747 8.21136 5.91796 8.02019 5.95598C7.82901 5.99401 7.6534 6.08786 7.51556 6.22569C7.37773 6.36352 7.28389 6.53913 7.24586 6.73031C7.20783 6.92149 7.22734 7.11964 7.30194 7.29972C7.37653 7.47981 7.50286 7.63372 7.66493 7.74202C7.827 7.85031 8.01753 7.9081 8.21245 7.9081C8.47365 7.90749 8.72398 7.80349 8.90867 7.61879C9.09336 7.4341 9.19741 7.18377 9.19802 6.92257ZM6.31968 6.92257C6.31968 6.72765 6.26185 6.53712 6.15355 6.37505C6.04526 6.21298 5.89135 6.08665 5.71126 6.01206C5.53118 5.93747 5.33302 5.91796 5.14185 5.95598C4.95067 5.99401 4.77506 6.08786 4.63723 6.22569C4.49939 6.36352 4.40555 6.53913 4.36752 6.73031C4.32949 6.92149 4.34901 7.11964 4.4236 7.29972C4.49819 7.47981 4.62452 7.63372 4.78659 7.74202C4.94866 7.85031 5.13919 7.9081 5.33411 7.9081C5.59531 7.90749 5.84564 7.80349 6.03033 7.61879C6.21503 7.4341 6.31907 7.18377 6.31968 6.92257Z"
										fill="#2AAAE1"
									/>
								</svg>
								<svg
									width={4}
									height={5}
									viewBox="0 0 4 5"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[26.72px] top-[22.33px]"
									preserveAspectRatio="none"
								>
									<path
										d="M1.84558 0.829102C2.16779 0.829102 2.48277 0.924642 2.75068 1.10365C3.01859 1.28267 3.2274 1.53711 3.3507 1.8348C3.47401 2.13249 3.50629 2.46005 3.44342 2.77607C3.38056 3.0921 3.22539 3.38238 2.99755 3.61022C2.76971 3.83806 2.47941 3.99322 2.16339 4.05608C1.84736 4.11894 1.51981 4.08668 1.22213 3.96337C0.924441 3.84007 0.669995 3.63125 0.490983 3.36334C0.311971 3.09543 0.216431 2.78045 0.216431 2.45823C0.217343 2.02644 0.389271 1.61259 0.694596 1.30727C0.999922 1.00194 1.41379 0.830014 1.84558 0.829102Z"
										fill="#00A78E"
									/>
								</svg>
								<svg
									width={5}
									height={5}
									viewBox="0 0 5 5"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[21.71px] top-[19.55px]"
									preserveAspectRatio="none"
								>
									<path
										d="M2.46474 0.0537298C2.9101 0.0544131 3.34526 0.187125 3.7152 0.435096C4.08513 0.683067 4.37325 1.03516 4.5431 1.44685C4.71296 1.85855 4.75692 2.31136 4.66945 2.74804C4.58198 3.18473 4.36697 3.58568 4.05166 3.90019C3.73634 4.2147 3.33487 4.42866 2.89797 4.51502C2.46106 4.60137 2.00835 4.55623 1.59709 4.38533C1.18583 4.21443 0.834486 3.92542 0.587461 3.55485C0.340436 3.18429 0.208837 2.74879 0.209292 2.30343C0.208835 2.00738 0.266902 1.71416 0.380159 1.44063C0.493415 1.16711 0.65961 0.918667 0.869216 0.709596C1.07882 0.500524 1.3277 0.33494 1.60152 0.222383C1.87534 0.109825 2.16869 0.0525155 2.46474 0.0537298Z"
										fill="#7AC144"
									/>
								</svg>
								<svg
									width={3}
									height={4}
									viewBox="0 0 3 4"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[20.87px] top-[16.27px]"
									preserveAspectRatio="none"
								>
									<path
										d="M1.64558 0.765651C1.89834 0.764969 2.14563 0.839253 2.35617 0.979111C2.56671 1.11897 2.73104 1.31812 2.8284 1.55138C2.92576 1.78464 2.95178 2.04153 2.90313 2.28957C2.85449 2.53761 2.73339 2.76564 2.55515 2.94485C2.3769 3.12407 2.14953 3.2464 1.90176 3.29638C1.65399 3.34636 1.39695 3.32175 1.16317 3.22565C0.929385 3.12956 0.729371 2.96629 0.588376 2.75651C0.447382 2.54673 0.371744 2.29985 0.37106 2.04709C0.369068 1.87884 0.40063 1.71187 0.46389 1.55596C0.527149 1.40004 0.620839 1.25829 0.739496 1.13899C0.858154 1.01969 0.999405 0.925234 1.15498 0.861133C1.31055 0.797032 1.47732 0.764569 1.64558 0.765651Z"
										fill="#2AAAE1"
									/>
								</svg>
								<svg
									width={3}
									height={3}
									viewBox="0 0 3 3"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[19.92px] top-[24.06px]"
									preserveAspectRatio="none"
								>
									<path
										d="M1.39991 0.564456C1.59369 0.564456 1.78311 0.621917 1.94424 0.729577C2.10536 0.837238 2.23096 0.990272 2.30512 1.1693C2.37928 1.34834 2.39868 1.54534 2.36088 1.7354C2.32307 1.92546 2.22975 2.10003 2.09272 2.23705C1.9557 2.37408 1.78111 2.4674 1.59105 2.50521C1.40099 2.54301 1.20397 2.52361 1.02494 2.44945C0.845906 2.37529 0.692907 2.24971 0.585247 2.08858C0.477586 1.92746 0.420108 1.73802 0.420108 1.54424C0.419804 1.41549 0.444938 1.28795 0.494069 1.16894C0.5432 1.04992 0.615354 0.941804 0.706396 0.850761C0.797438 0.759719 0.905577 0.687548 1.02459 0.638417C1.1436 0.589286 1.27116 0.564152 1.39991 0.564456Z"
										fill="#2AAAE1"
									/>
								</svg>
								<svg
									width={4}
									height={3}
									viewBox="0 0 4 3"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[18.31px] top-[13.7px]"
									preserveAspectRatio="none"
								>
									<path
										d="M2.10692 0.198243C2.36313 0.198698 2.61346 0.275059 2.8263 0.417684C3.03914 0.56031 3.20494 0.762805 3.30278 0.999598C3.40061 1.23639 3.4261 1.49686 3.376 1.74813C3.32591 1.99939 3.20247 2.23018 3.0213 2.41134C2.84014 2.59251 2.60937 2.71593 2.35811 2.76602C2.10685 2.81612 1.84637 2.79065 1.60957 2.69281C1.37278 2.59497 1.17028 2.42917 1.02765 2.21633C0.885027 2.00349 0.808684 1.75316 0.808228 1.49695C0.808077 1.32636 0.841572 1.15742 0.906784 0.999782C0.971997 0.842147 1.06763 0.698917 1.18826 0.578291C1.30889 0.457665 1.45212 0.362003 1.60975 0.29679C1.76738 0.231578 1.93633 0.198091 2.10692 0.198243Z"
										fill="#2AAAE1"
									/>
								</svg>
								<svg
									width={10}
									height={13}
									viewBox="0 0 10 13"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[10.53px] top-[16.13px]"
									preserveAspectRatio="none"
								>
									<path
										d="M9.79203 5.49942C9.79256 6.73915 9.32104 7.93258 8.47332 8.83718C7.62561 9.74178 6.46528 10.2897 5.22813 10.3696L3.75212 12.153L3.43319 10.1577C2.57442 9.88478 1.80798 9.3794 1.2188 8.6976C0.629611 8.0158 0.240685 7.1842 0.0951135 6.29493C-0.050458 5.40566 0.0530096 4.49344 0.39405 3.65937C0.735091 2.82529 1.30039 2.10192 2.02731 1.5694C2.75423 1.03688 3.61439 0.715996 4.51248 0.642319C5.41057 0.568643 6.31152 0.745045 7.11551 1.15198C7.9195 1.55891 8.59513 2.18048 9.06754 2.94782C9.53996 3.71516 9.79072 4.59832 9.79203 5.49942ZM7.2706 5.49942C7.2706 5.38033 7.23528 5.26391 7.16911 5.16488C7.10295 5.06586 7.00891 4.98869 6.89888 4.94311C6.78885 4.89754 6.66779 4.88561 6.55098 4.90885C6.43418 4.93208 6.32688 4.98942 6.24266 5.07363C6.15845 5.15785 6.10111 5.26515 6.07788 5.38195C6.05464 5.49876 6.06656 5.61982 6.11213 5.72985C6.15771 5.83988 6.23489 5.93393 6.33391 6.00009C6.43293 6.06626 6.54935 6.10157 6.66844 6.10157C6.74756 6.10172 6.82593 6.08625 6.89906 6.05605C6.97218 6.02584 7.03863 5.98149 7.09457 5.92554C7.15052 5.8696 7.19486 5.80316 7.22507 5.73004C7.25527 5.65691 7.27075 5.57854 7.2706 5.49942ZM5.51136 5.49942C5.51136 5.38033 5.47604 5.26391 5.40987 5.16488C5.34371 5.06586 5.24967 4.98869 5.13964 4.94311C5.02961 4.89754 4.90855 4.88561 4.79174 4.90885C4.67493 4.93208 4.56763 4.98942 4.48342 5.07363C4.39921 5.15785 4.34187 5.26515 4.31863 5.38195C4.2954 5.49876 4.30732 5.61982 4.35289 5.72985C4.39847 5.83988 4.47565 5.93393 4.57467 6.00009C4.67369 6.06626 4.79011 6.10157 4.9092 6.10157C4.98832 6.10172 5.06669 6.08625 5.13981 6.05605C5.21294 6.02584 5.27938 5.98149 5.33533 5.92554C5.39127 5.8696 5.43562 5.80316 5.46582 5.73004C5.49603 5.65691 5.51151 5.57854 5.51136 5.49942ZM3.75212 5.49942C3.75212 5.38033 3.71679 5.26391 3.65063 5.16488C3.58446 5.06586 3.49043 4.98869 3.3804 4.94311C3.27037 4.89754 3.1493 4.88561 3.0325 4.90885C2.91569 4.93208 2.80839 4.98942 2.72418 5.07363C2.63997 5.15785 2.58263 5.26515 2.55939 5.38195C2.53616 5.49876 2.54808 5.61982 2.59365 5.72985C2.63923 5.83988 2.71641 5.93393 2.81543 6.00009C2.91445 6.06626 3.03087 6.10157 3.14996 6.10157C3.22908 6.10172 3.30745 6.08625 3.38057 6.05605C3.4537 6.02584 3.52014 5.98149 3.57609 5.92554C3.63203 5.8696 3.67638 5.80316 3.70658 5.73004C3.73679 5.65691 3.75227 5.57854 3.75212 5.49942Z"
										fill="#00A78E"
									/>
								</svg>
								<svg
									width={4}
									height={4}
									viewBox="0 0 4 4"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[16.37px] top-[26.91px]"
									preserveAspectRatio="none"
								>
									<path
										d="M2.27171 0.410156C2.54838 0.410156 2.81884 0.492209 3.04888 0.645919C3.27892 0.799629 3.4582 1.01808 3.56408 1.27369C3.66996 1.5293 3.69767 1.81057 3.6437 2.08193C3.58972 2.35328 3.45649 2.60254 3.26085 2.79817C3.06522 2.99381 2.81596 3.12704 2.54461 3.18101C2.27325 3.23499 1.99199 3.20731 1.73637 3.10143C1.48076 2.99555 1.26228 2.81624 1.10857 2.5862C0.954855 2.35615 0.872803 2.0857 0.872803 1.80903C0.872803 1.43802 1.02018 1.08222 1.28252 0.819877C1.54486 0.557537 1.9007 0.410156 2.27171 0.410156Z"
										fill="#7AC144"
									/>
								</svg>
								<svg
									width={4}
									height={4}
									viewBox="0 0 4 4"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[13.43px] top-[13.76px]"
									preserveAspectRatio="none"
								>
									<path
										d="M2.98648 2.98575C3.48477 2.39119 3.40674 1.50526 2.81218 1.00696C2.21762 0.50867 1.33169 0.586709 0.833392 1.18127C0.335099 1.77583 0.413138 2.66176 1.0077 3.16005C1.60226 3.65835 2.48819 3.58031 2.98648 2.98575Z"
										fill="#00A78E"
									/>
								</svg>
								<svg
									width={8}
									height={9}
									viewBox="0 0 8 9"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[9.77px] top-[29.25px]"
									preserveAspectRatio="none"
								>
									<path
										d="M4.07972 0.753906C3.32558 0.753906 2.58837 0.977521 1.96131 1.39647C1.33426 1.81542 0.845507 2.41089 0.556859 3.1076C0.268211 3.8043 0.192625 4.57096 0.339666 5.31062C0.486707 6.05028 0.849767 6.72972 1.38294 7.26306C1.91611 7.79639 2.59546 8.15968 3.33508 8.30695C4.0747 8.45421 4.84138 8.37884 5.53818 8.0904C6.23497 7.80197 6.8306 7.31341 7.24974 6.68648C7.66888 6.05955 7.89271 5.3224 7.89294 4.56827C7.89141 3.5573 7.48921 2.58817 6.77445 1.8732C6.0597 1.15823 5.09068 0.755733 4.07972 0.753906ZM5.9633 4.76861L3.23002 6.34478C3.17743 6.37499 3.11503 6.38324 3.0564 6.36772C2.99776 6.3522 2.94761 6.31417 2.91685 6.26189C2.89842 6.22622 2.88819 6.18688 2.88692 6.14675V2.98862C2.88692 2.92755 2.91118 2.86899 2.95436 2.8258C2.99755 2.78262 3.05613 2.75838 3.1172 2.75838C3.15746 2.75871 3.197 2.76899 3.23232 2.78831L5.9656 4.36448C5.99226 4.37971 6.01559 4.40014 6.03424 4.42453C6.0529 4.44891 6.06649 4.47678 6.07421 4.5065C6.08193 4.53621 6.08365 4.56715 6.07923 4.59754C6.07482 4.62792 6.06436 4.65712 6.04849 4.68341C6.03115 4.72106 6.00095 4.75128 5.9633 4.76861Z"
										fill="#00A78E"
									/>
								</svg>
								<svg
									width={7}
									height={7}
									viewBox="0 0 7 7"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[7.25px] top-[11.14px]"
									preserveAspectRatio="none"
								>
									<path
										d="M3.51978 0.641602C4.06759 0.642285 4.6029 0.80531 5.0581 1.11008C5.51331 1.41486 5.86797 1.8477 6.07729 2.35395C6.28661 2.86019 6.34121 3.41711 6.23417 3.95436C6.12713 4.49161 5.86327 4.98509 5.4759 5.37245C5.08854 5.75981 4.59507 6.02367 4.05782 6.13071C3.52057 6.23775 2.96365 6.18316 2.45741 5.97384C1.95117 5.76452 1.51831 5.40986 1.21354 4.95465C0.908769 4.49945 0.74574 3.96413 0.745056 3.41632C0.744905 3.0519 0.816571 2.69102 0.95596 2.3543C1.09535 2.01759 1.29973 1.71165 1.55742 1.45396C1.8151 1.19627 2.12105 0.991897 2.45776 0.852508C2.79447 0.713119 3.15536 0.64145 3.51978 0.641602ZM4.98428 3.56369C5.00411 3.55176 5.02137 3.53602 5.03507 3.51737C5.04877 3.49872 5.05863 3.47754 5.06409 3.45506C5.06955 3.43257 5.07049 3.40923 5.06687 3.38637C5.06325 3.36352 5.05514 3.34161 5.04299 3.32191C5.02805 3.2982 5.00799 3.27814 4.98428 3.26319L2.81746 2.01169C2.79813 1.99999 2.77667 1.99223 2.75432 1.98885C2.73198 1.98547 2.70918 1.98654 2.68725 1.99199C2.66532 1.99745 2.64468 2.00719 2.62652 2.02065C2.60836 2.0341 2.59304 2.05101 2.58144 2.07041C2.56524 2.09712 2.55687 2.12783 2.55726 2.15906V4.65631C2.55808 4.7021 2.57625 4.74587 2.60809 4.77878C2.63993 4.81169 2.68308 4.83129 2.72882 4.83362C2.76005 4.83401 2.79076 4.82563 2.81746 4.80944L4.98428 3.56369Z"
										fill="#7AC144"
									/>
								</svg>
								<svg
									width={6}
									height={6}
									viewBox="0 0 6 6"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[6.33px] top-9"
									preserveAspectRatio="none"
								>
									<path
										d="M3.29703 0.495117C3.78502 0.495117 4.26204 0.63984 4.66779 0.910951C5.07354 1.18206 5.38978 1.56738 5.57653 2.01823C5.76327 2.46907 5.81213 2.96519 5.71693 3.4438C5.62173 3.92241 5.38674 4.36205 5.04168 4.70711C4.69662 5.05217 4.25699 5.28715 3.77838 5.38236C3.29976 5.47756 2.80367 5.4287 2.35283 5.24195C1.90199 5.05521 1.51664 4.73894 1.24553 4.3332C0.974417 3.92745 0.829712 3.45042 0.829712 2.96244C0.831535 2.30862 1.09208 1.68211 1.55439 1.2198C2.01671 0.75748 2.64322 0.49694 3.29703 0.495117Z"
										fill="#2AAAE1"
									/>
								</svg>
								<svg
									width={2}
									height={3}
									viewBox="0 0 2 3"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[8.56px] top-[17.3px]"
									preserveAspectRatio="none"
								>
									<path
										d="M1.02357 2.73635C1.55833 2.73635 1.99184 2.30284 1.99184 1.76808C1.99184 1.23332 1.55833 0.799805 1.02357 0.799805C0.488809 0.799805 0.0552979 1.23332 0.0552979 1.76808C0.0552979 2.30284 0.488809 2.73635 1.02357 2.73635Z"
										fill="#2AAAE1"
									/>
								</svg>
								<svg
									width={2}
									height={2}
									viewBox="0 0 2 2"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[8.12px] top-[33.56px]"
									preserveAspectRatio="none"
								>
									<path
										d="M1.29818 1.42205C1.67335 1.42205 1.97747 1.11793 1.97747 0.742765C1.97747 0.367604 1.67335 0.0634766 1.29818 0.0634766C0.923024 0.0634766 0.618896 0.367604 0.618896 0.742765C0.618896 1.11793 0.923024 1.42205 1.29818 1.42205Z"
										fill="#7AC144"
									/>
								</svg>
								<svg
									width={6}
									height={6}
									viewBox="0 0 6 6"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[4.26px] top-[28.13px]"
									preserveAspectRatio="none"
								>
									<path
										d="M3.22464 0.631838C3.71331 0.631156 4.19122 0.775379 4.59791 1.0463C5.00461 1.31723 5.32183 1.70268 5.50946 2.15389C5.6971 2.60511 5.74673 3.10181 5.65206 3.58122C5.5574 4.06064 5.3227 4.50122 4.97764 4.84724C4.63258 5.19327 4.19265 5.42922 3.71351 5.52523C3.23436 5.62123 2.73751 5.57299 2.28577 5.38661C1.83404 5.20024 1.44771 4.88407 1.17565 4.47814C0.903592 4.0722 0.758015 3.59471 0.757331 3.10604C0.756574 2.78149 0.819832 2.45998 0.943473 2.1599C1.06711 1.85982 1.24871 1.58707 1.47788 1.35726C1.70705 1.12744 1.9793 0.945103 2.27903 0.820624C2.57876 0.696144 2.90009 0.631989 3.22464 0.631838Z"
										fill="#7AC144"
									/>
								</svg>
								<svg
									width={5}
									height={5}
									viewBox="0 0 5 5"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[4.82px] top-[41.43px]"
									preserveAspectRatio="none"
								>
									<path
										d="M2.36169 0.926774C2.76451 0.926774 3.15829 1.04626 3.49322 1.27005C3.82816 1.49385 4.0892 1.81192 4.24336 2.18408C4.39751 2.55624 4.43785 2.96577 4.35926 3.36085C4.28068 3.75594 4.0867 4.11885 3.80186 4.40369C3.51702 4.68853 3.15411 4.8825 2.75903 4.96109C2.36395 5.03967 1.95442 4.99936 1.58226 4.84521C1.2101 4.69105 0.892016 4.42999 0.668219 4.09506C0.444422 3.76012 0.324967 3.36629 0.324967 2.96347C0.323901 2.6957 0.375858 2.4304 0.477835 2.18281C0.579812 1.93523 0.729795 1.71026 0.919134 1.52092C1.10847 1.33158 1.33342 1.18166 1.58101 1.07969C1.82859 0.977709 2.09392 0.925708 2.36169 0.926774Z"
										fill="#2AAAE1"
									/>
								</svg>
								<svg
									width={3}
									height={2}
									viewBox="0 0 3 2"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[6.45px] top-[9.5px]"
									preserveAspectRatio="none"
								>
									<path
										d="M1.82796 3.05018e-06C2.0008 3.05018e-06 2.16975 0.0512543 2.31345 0.147276C2.45716 0.243297 2.56917 0.379776 2.63531 0.539454C2.70145 0.699131 2.71875 0.874836 2.68503 1.04435C2.65132 1.21386 2.56809 1.36957 2.44588 1.49178C2.32367 1.61399 2.16796 1.69722 1.99845 1.73094C1.82894 1.76466 1.65323 1.74735 1.49356 1.68121C1.33388 1.61507 1.1974 1.50307 1.10138 1.35936C1.00536 1.21565 0.954105 1.0467 0.954105 0.873867C0.953801 0.759024 0.976194 0.645254 1.02 0.539095C1.06381 0.432935 1.12817 0.336481 1.20938 0.255274C1.29058 0.174068 1.38704 0.109711 1.4932 0.0659032C1.59936 0.022095 1.71312 -0.000300768 1.82796 3.05018e-06Z"
										fill="#2AAAE1"
									/>
								</svg>
								<svg
									width={4}
									height={3}
									viewBox="0 0 4 3"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[4.08px] top-[33.56px]"
									preserveAspectRatio="none"
								>
									<path
										d="M1.90406 2.70925C2.63467 2.70925 3.22695 2.11697 3.22695 1.38636C3.22695 0.655752 2.63467 0.0634766 1.90406 0.0634766C1.17345 0.0634766 0.581177 0.655752 0.581177 1.38636C0.581177 2.11697 1.17345 2.70925 1.90406 2.70925Z"
										fill="#00A78E"
									/>
								</svg>
								<svg
									width={5}
									height={5}
									viewBox="0 0 5 5"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[1.54px] top-[37.56px]"
									preserveAspectRatio="none"
								>
									<path
										d="M2.0677 0.0605482C2.4698 0.0600934 2.86299 0.178871 3.19759 0.401859C3.53218 0.624847 3.79315 0.942034 3.9475 1.31332C4.10184 1.68461 4.14264 2.09334 4.06473 2.48781C3.98681 2.88228 3.79369 3.2448 3.50977 3.52952C3.22585 3.81425 2.86389 4.00838 2.46964 4.08741C2.07539 4.16644 1.66656 4.1268 1.29484 3.9735C0.923113 3.82021 0.605186 3.56016 0.381252 3.22619C0.157318 2.89223 0.0374317 2.49937 0.0367484 2.09728C0.0361429 1.83012 0.0882185 1.56549 0.189998 1.31849C0.291778 1.07148 0.441264 0.846961 0.629901 0.65779C0.818538 0.468618 1.04262 0.318503 1.28934 0.216025C1.53605 0.113546 1.80055 0.0606989 2.0677 0.0605482Z"
										fill="#00A78E"
									/>
								</svg>
								<svg
									width={5}
									height={5}
									viewBox="0 0 5 5"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[1.04px] top-[24.06px]"
									preserveAspectRatio="none"
								>
									<path
										d="M2.57724 0.564469C2.97933 0.565152 3.37219 0.685043 3.70616 0.908977C4.04012 1.13291 4.30019 1.45084 4.45348 1.82257C4.60678 2.19429 4.64641 2.60311 4.56738 2.99735C4.48835 3.3916 4.29421 3.75357 4.00948 4.03749C3.72476 4.3214 3.36225 4.51454 2.96777 4.59246C2.5733 4.67037 2.16459 4.62957 1.7933 4.47523C1.42201 4.32088 1.10482 4.05991 0.881835 3.72532C0.658847 3.39072 0.540074 2.99753 0.540529 2.59543C0.540223 2.32815 0.592737 2.06344 0.695055 1.81652C0.797372 1.5696 0.947475 1.34533 1.13674 1.1566C1.326 0.96787 1.55069 0.818419 1.7979 0.716801C2.04511 0.615183 2.30996 0.563407 2.57724 0.564469Z"
										fill="#2AAAE1"
									/>
								</svg>
								<svg
									width={5}
									height={5}
									viewBox="0 0 5 5"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[-0.38px] top-[28.64px]"
									preserveAspectRatio="none"
								>
									<path
										d="M2.15415 0.139649C2.55624 0.140332 2.9491 0.260188 3.28306 0.484122C3.61702 0.708056 3.87709 1.026 4.03039 1.39773C4.18368 1.76945 4.22332 2.17829 4.14429 2.57253C4.06526 2.96678 3.87111 3.32875 3.58639 3.61266C3.30166 3.89658 2.93915 4.08969 2.54468 4.1676C2.15021 4.24552 1.74149 4.20473 1.37021 4.05039C0.998917 3.89604 0.681729 3.63508 0.458741 3.30048C0.235753 2.96589 0.116978 2.57267 0.117433 2.17058C0.118653 1.63131 0.33381 1.11458 0.715668 0.733798C1.09753 0.353019 1.61488 0.139342 2.15415 0.139649Z"
										fill="#00A78E"
									/>
								</svg>
								<svg
									width={5}
									height={5}
									viewBox="0 0 5 5"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[-0.5px] top-[33.22px]"
									preserveAspectRatio="none"
								>
									<path
										d="M2.03673 0.720708C2.30382 0.721086 2.56821 0.774083 2.81483 0.876642C3.06144 0.979201 3.28543 1.12932 3.47402 1.31844C3.66262 1.50757 3.81211 1.73199 3.91397 1.97889C4.01583 2.22579 4.06806 2.49035 4.06769 2.75744C4.06731 3.02452 4.01433 3.28891 3.91177 3.53552C3.80921 3.78213 3.65908 4.00615 3.46995 4.19474C3.28083 4.38333 3.05641 4.53282 2.80951 4.63468C2.56261 4.73654 2.29806 4.78878 2.03097 4.7884C1.76369 4.78871 1.49899 4.73619 1.25207 4.63387C1.00515 4.53156 0.780878 4.38144 0.59215 4.19218C0.403422 4.00292 0.253955 3.77823 0.152337 3.53102C0.0507193 3.28382 -0.001046 3.01895 1.60157e-05 2.75167C0.00016669 2.48452 0.0529926 2.22002 0.155471 1.97331C0.25795 1.72659 0.40807 1.50251 0.597241 1.31387C0.786413 1.12524 1.01092 0.975751 1.25793 0.873971C1.50493 0.772192 1.76958 0.720103 2.03673 0.720708Z"
										fill="#7AC144"
									/>
								</svg>
								<svg
									width={9}
									height={7}
									viewBox="0 0 9 7"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="absolute left-[34.91px] top-[16.98px]"
									preserveAspectRatio="none"
								>
									<path
										d="M4.76026 4.78978L4.53574 5.24454L5.60999 5.20886L8.9569 5.10869L6.19367 2.8774C6.07518 2.2214 5.73564 1.62578 5.23151 1.18963C4.72738 0.753488 4.08906 0.503133 3.42285 0.480238C2.75663 0.457343 2.10266 0.663287 1.56978 1.06379C1.03689 1.4643 0.657231 2.03522 0.493982 2.68153C0.330734 3.32784 0.393769 4.01057 0.672543 4.61609C0.951317 5.2216 1.42908 5.71339 2.02626 6.00961C2.62344 6.30583 3.30403 6.38862 3.95481 6.24418C4.60558 6.09975 5.18724 5.73681 5.60303 5.21577L4.52886 5.25145L4.76026 4.78978ZM2.13294 3.80423C2.02408 3.805 1.91938 3.76249 1.84187 3.68605C1.76435 3.60962 1.72036 3.50551 1.7196 3.39666C1.71883 3.2878 1.76136 3.18309 1.83779 3.10557C1.91423 3.02806 2.01831 2.9841 2.12717 2.98333C2.18082 2.98287 2.23401 2.99309 2.28367 3.01341C2.33333 3.03373 2.37847 3.06373 2.41641 3.10167C2.45435 3.13961 2.48435 3.18472 2.50467 3.23438C2.52499 3.28404 2.53521 3.33724 2.53475 3.39089C2.53744 3.44481 2.52903 3.49871 2.51001 3.54923C2.491 3.59976 2.46179 3.64585 2.42421 3.68461C2.38664 3.72338 2.34145 3.75398 2.29154 3.77456C2.24163 3.79514 2.18691 3.80525 2.13294 3.80423ZM3.30732 3.80423C3.22671 3.80423 3.14786 3.78033 3.08083 3.73554C3.01381 3.69076 2.96158 3.6271 2.93073 3.55262C2.89988 3.47815 2.89182 3.3962 2.90754 3.31714C2.92327 3.23808 2.96206 3.16545 3.01906 3.10845C3.07606 3.05145 3.14871 3.01264 3.22777 2.99691C3.30683 2.98119 3.38878 2.98926 3.46325 3.0201C3.53773 3.05095 3.60139 3.1032 3.64617 3.17022C3.69096 3.23725 3.71483 3.31605 3.71483 3.39666C3.71576 3.45034 3.70596 3.50366 3.68587 3.55345C3.66579 3.60324 3.63588 3.64849 3.59796 3.68651C3.56005 3.72453 3.51489 3.75455 3.46515 3.77477C3.41541 3.79499 3.361 3.80501 3.30732 3.80423ZM4.07525 3.39089C4.07525 3.31028 4.09912 3.23148 4.14391 3.16446C4.18869 3.09743 4.25235 3.04521 4.32683 3.01436C4.4013 2.98351 4.48325 2.97543 4.56231 2.99115C4.64137 3.00688 4.71401 3.04571 4.77101 3.10271C4.82801 3.15971 4.86681 3.23232 4.88254 3.31138C4.89826 3.39044 4.89019 3.47239 4.85935 3.54686C4.8285 3.62134 4.77627 3.685 4.70925 3.72978C4.64222 3.77456 4.56344 3.79847 4.48283 3.79847C4.42905 3.79941 4.37557 3.78951 4.3257 3.76936C4.27583 3.74921 4.23057 3.71922 4.19254 3.68119C4.1545 3.64315 4.1245 3.59784 4.10434 3.54797C4.08419 3.4981 4.07432 3.44467 4.07525 3.39089Z"
										fill="#2AAAE1"
									/>
								</svg>
								<div className="w-[207px] h-9 hidden sm:block">
									<p
										className="w-[153px] h-9 absolute left-[98.46px] top-2.5 text-2xl font-bold text-left text-[#00a78e]">
										SYMPHONY
									</p>
									<p
										className="w-[58px] h-9 absolute left-[44.46px] top-2.5 text-2xl font-bold text-left text-[#2aaae1]">
										CLIP
									</p>
								</div>
							</div>
						</div>
						<div className="flex items-center space-x-4">
							<nav
								className={`flex-col md:flex-row items-center space-x-8 md:flex hidden dark:text-white list-none lg:flex`}>
								<li>
									<a className={(page === "" || page === "home") ? "active" : ""}>
										{i18next.t("Home")}
									</a>
								</li>
								<li>
									<a onClick={this.navigate("#pricing")} className={page === "#pricing" ? "active" : ""}>
										{i18next.t("Pricing")}
									</a>
								</li>
								<li>
									<a onClick={() => this.redirectGetStarted("app/login")}>
										{i18next.t("Login")}
									</a>
								</li>
								<div
									className="flex cursor-pointer justify-start items-start flex-grow-0 flex-shrink-0 relative py-2 px-4 rounded-lg border border-[#191a23] dark:border-white">
									<a href={"/app/signup"}>
										<p className="flex-grow-0 flex-shrink-0 text-lg text-center dark:text-white">
											{i18next.t("Get Started for Free")}
										</p>
									</a>
								</div>
							</nav>
						</div>
						<div className="flex items-center space-x-4">
							<div className="relative">
								<button
									onClick={() => this.setState({isLangOpen: !this.state.isLangOpen})}
									className="flex items-center justify-center w-10 h-10 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 focus:outline-none"
									aria-haspopup="listbox"
									aria-expanded={this.state.isLangOpen}
								>
									<img
										src={this.state.language === 'en'
											? 'https://storage.googleapis.com/clipsymphony_static_assets/Icons/gb.svg'
											: this.state.language === 'de'
												? 'https://storage.googleapis.com/clipsymphony_static_assets/Icons/de.svg'
												: this.state.language === 'fr'
													? 'https://storage.googleapis.com/clipsymphony_static_assets/Icons/fr.svg'
													: 'https://storage.googleapis.com/clipsymphony_static_assets/Icons/es.svg'}
										alt={this.state.language.toUpperCase()}
										className="w-6 h-6"
									/>
								</button>
								{this.state.isLangOpen && (
									<div className="absolute right-0 mt-2 w-36 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5 z-50">
										<ul className="py-1 max-h-60 overflow-auto" role="listbox">
											{[
												{code: 'en', label: 'EN', flag: 'https://storage.googleapis.com/clipsymphony_static_assets/Icons/gb.svg'},
												{code: 'de', label: 'DE', flag: 'https://storage.googleapis.com/clipsymphony_static_assets/Icons/de.svg'},
												{code: 'fr', label: 'FR', flag: 'https://storage.googleapis.com/clipsymphony_static_assets/Icons/fr.svg'},
												{code: 'es', label: 'ES', flag: 'https://storage.googleapis.com/clipsymphony_static_assets/Icons/es.svg'},
											]
												.filter(l => l.code !== this.state.language)
												.map(l => (
													<li key={l.code} role="option">
														<button
															onClick={() => { this.changeLanguage(l.code)(); this.setState({isLangOpen: false}); }}
															className="w-full px-3 py-2 flex items-center text-sm hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none"
														>
															<img src={l.flag} alt={l.label} className="w-5 h-5 mr-2"/>
															<span className="text-gray-700 dark:text-gray-200">{l.label}</span>
														</button>
													</li>
												))}
										</ul>
									</div>
								)}
							</div>
							<button onClick={this.toggleDarkMode} className="focus:outline-none">
								{this.state.isDarkMode ? <SunIcon className="w-6 h-6 text-yellow-500"/> :
									<MoonIcon className="w-6 h-6 text-gray-500"/>}
							</button>
							<button onClick={this.toggleMobileMenu} className="md:hidden focus:outline-none">
								{this.state.isMobileMenuOpen ? <XIcon className="w-6 h-6 text-black dark:!text-white"/> :
									<MenuIcon className="w-6 h-6 text-black dark:!text-white"/>}
							</button>
						</div>
					</div>
					{this.state.isMobileMenuOpen && (
						<div className="lg:hidden bg-white dark:!bg-gray-900">
							<nav className="flex flex-col list-none border-t text-center dark:text-white space-y-2 p-4">
								<li>
									<a className={(page === "" || page === "home") ? "active" : ""} onClick={this.navigate("home")}>
										{i18next.t("Home")}
									</a>
								</li>
								<li>
									<a onClick={this.navigate("#pricing")} className={page === "#pricing" ? "active" : ""}>
										{i18next.t("Pricing")}
									</a>
								</li>
								<li>
									<a onClick={() => this.redirectGetStarted("app/login")}>
										{i18next.t("Login")}
									</a>
								</li>
								<li className="get-started" onClick={() => this.redirectGetStarted("app/signup")}>
									<a>{i18next.t("Get Started")}</a>
								</li>
							</nav>
						</div>
					)}
				</header>
				<div className={"bg-white dark:!bg-gray-900 px-4 md:px-16"}>
					<Switch>
						<Route path="/about"> <AboutPage language={this.state.language}/> </Route>
						<Route path="/contact"> <ContactPage language={this.state.language}/> </Route>
						<Route path="/jobs"> <JobsPage history={history}/> </Route>
						<Route path="/careers"> <JobsPage history={history}/> </Route>
						<Route path="/job"> <JobsPage history={history}/> </Route>
						<Route path="/hiring"> <JobsPage history={history}/> </Route>
						<Route path="/terms"> <TermsAndConditionsPage/> </Route>
						<Route path="/terms-and-conditions"> <TermsAndConditionsPage/> </Route>
						<Route path="/home"> <App signUp={this.redirectGetStarted} history={history}/> </Route>
						<Route path="/"> <App signUp={this.redirectGetStarted} history={history}/> </Route>
						<Route path="*"> <App signUp={this.redirectGetStarted} history={history}/> </Route>
					</Switch>
				</div>
				<div className="flex flex-col bg-white dark:!bg-gray-800 justify-start items-start px-8">
					<div
						className="flex flex-col justify-start w-full items-start gap-12 px-16 pt-14 pb-12 rounded-tl-lg rounded-tr-lg bg-[#191a23] dark:bg-gray-800">
						<div className="flex w-[96%] md:flex-row flex-col justify-between items-start gap-16">
							<div>
								<div className="flex justify-start items-center w-full gap-40">
									<div className="flex justify-start items-start relative overflow-hidden gap-2.5 py-2.5">
										<div className="flex-grow-0 flex-shrink-0 w-[202.56px] h-[29px]">
											<svg
												width={5}
												height={5}
												viewBox="0 0 5 5"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute cursor-pointer left-[25.51px] top-[21.17px]"
												preserveAspectRatio="none"
											>
												<path
													d="M2.05814 0.669434C2.46353 0.669434 2.85984 0.789644 3.19691 1.01486C3.53397 1.24008 3.79669 1.5602 3.95182 1.93473C4.10696 2.30926 4.14752 2.72138 4.06843 3.11898C3.98935 3.51657 3.79416 3.88178 3.50751 4.16843C3.22086 4.45508 2.85561 4.65031 2.45802 4.72939C2.06042 4.80848 1.64832 4.76789 1.2738 4.61275C0.899269 4.45762 0.579151 4.19491 0.353931 3.85784C0.128711 3.52078 0.0085144 3.12449 0.0085144 2.71911C0.0085144 2.1755 0.224446 1.65415 0.608833 1.26977C0.99322 0.885379 1.51454 0.669434 2.05814 0.669434ZM2.9235 2.87585C2.96561 2.85107 2.99624 2.81068 3.00875 2.76344C3.02125 2.71621 3.01458 2.66595 2.99024 2.62358C2.97573 2.59472 2.95235 2.5713 2.9235 2.5568L1.91532 1.97158C1.89387 1.95899 1.87008 1.95083 1.84541 1.94761C1.82075 1.94439 1.79568 1.94617 1.77171 1.95283C1.74774 1.95949 1.7254 1.97091 1.70593 1.9864C1.68647 2.00189 1.67032 2.02113 1.65844 2.04299C1.6435 2.07169 1.63526 2.1034 1.63433 2.13574V3.30062C1.63432 3.32537 1.63926 3.34988 1.64887 3.37269C1.65849 3.3955 1.67254 3.41616 1.69025 3.43344C1.70797 3.45073 1.72897 3.46429 1.75201 3.47334C1.77506 3.48238 1.79967 3.48672 1.82441 3.4861C1.85683 3.48576 1.88871 3.47748 1.91719 3.46199L2.9235 2.87585Z"
													fill="white"
												/>
											</svg>
											<svg
												width={3}
												height={3}
												viewBox="0 0 3 3"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute cursor-pointer left-[26.29px] top-[26.17px]"
												preserveAspectRatio="none"
											>
												<path
													d="M1.79662 2.67644C2.35084 2.67644 2.80012 2.22715 2.80012 1.67294C2.80012 1.11872 2.35084 0.669434 1.79662 0.669434C1.2424 0.669434 0.793121 1.11872 0.793121 1.67294C0.793121 2.22715 1.2424 2.67644 1.79662 2.67644Z"
													fill="white"
												/>
											</svg>
											<svg
												width={2}
												height={2}
												viewBox="0 0 2 2"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute cursor-pointer left-[26.39px] top-[17.67px]"
												preserveAspectRatio="none"
											>
												<path
													d="M1.44051 1.26456C1.74271 1.26456 1.9877 1.01957 1.9877 0.717362C1.9877 0.415154 1.74271 0.170166 1.44051 0.170166C1.1383 0.170166 0.893311 0.415154 0.893311 0.717362C0.893311 1.01957 1.1383 1.26456 1.44051 1.26456Z"
													fill="white"
												/>
											</svg>
											<svg
												width={4}
												height={3}
												viewBox="0 0 4 3"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute cursor-pointer left-[24.44px] top-[18.92px]"
												preserveAspectRatio="none"
											>
												<path
													d="M2.00851 2.55242C2.59705 2.55242 3.07415 2.07532 3.07415 1.48678C3.07415 0.898246 2.59705 0.421143 2.00851 0.421143C1.41997 0.421143 0.942871 0.898246 0.942871 1.48678C0.942871 2.07532 1.41997 2.55242 2.00851 2.55242Z"
													fill="white"
												/>
											</svg>
											<svg
												width={13}
												height={11}
												viewBox="0 0 13 11"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute cursor-pointer left-[14.05px] top-[22.7px]"
												preserveAspectRatio="none"
											>
												<path
													d="M7.11433 0.195557C7.94408 0.196235 8.76196 0.392875 9.50134 0.769468C10.2407 1.14606 10.8807 1.69196 11.3692 2.3627C11.8576 3.03345 12.1808 3.81007 12.3123 4.62934C12.4438 5.44861 12.38 6.28736 12.126 7.07728C11.8719 7.86721 11.435 8.58598 10.8506 9.17506C10.2662 9.76413 9.55098 10.2069 8.76312 10.4672C7.97526 10.7275 7.13706 10.7981 6.31676 10.6732C5.49646 10.5483 4.71727 10.2314 4.04263 9.74829L0.551697 9.55353L2.08756 7.04943C1.83829 6.26 1.77859 5.42291 1.91335 4.6061C2.04811 3.78929 2.37352 3.01576 2.86316 2.34824C3.3528 1.68072 3.99289 1.13803 4.73151 0.764175C5.47013 0.390317 6.28648 0.195825 7.11433 0.196491V0.195557ZM10.2343 5.4644C10.2343 5.30739 10.1877 5.15391 10.1005 5.02335C10.0133 4.89279 9.88927 4.79103 9.74421 4.73095C9.59914 4.67086 9.43949 4.65514 9.28549 4.68577C9.13149 4.71641 8.99005 4.792 8.87903 4.90303C8.768 5.01406 8.69237 5.15553 8.66174 5.30953C8.63111 5.46353 8.64682 5.62315 8.70691 5.76821C8.767 5.91328 8.86876 6.03726 8.99932 6.1245C9.12987 6.21173 9.28338 6.25829 9.4404 6.25829C9.6508 6.2578 9.85243 6.17402 10.0012 6.02524C10.15 5.87646 10.2338 5.67481 10.2343 5.4644ZM7.90918 5.4644C7.90918 5.30739 7.86259 5.15391 7.77536 5.02335C7.68812 4.89279 7.56414 4.79103 7.41907 4.73095C7.27401 4.67086 7.11439 4.65514 6.96038 4.68577C6.80638 4.71641 6.66492 4.792 6.55389 4.90303C6.44286 5.01406 6.36726 5.15553 6.33663 5.30953C6.306 5.46353 6.32171 5.62315 6.3818 5.76821C6.44189 5.91328 6.54365 6.03726 6.67421 6.1245C6.80476 6.21173 6.95824 6.25829 7.11526 6.25829C7.32567 6.2578 7.52732 6.17402 7.6761 6.02524C7.82487 5.87646 7.90869 5.67481 7.90918 5.4644ZM5.59055 5.4644C5.59055 5.30739 5.54396 5.15391 5.45673 5.02335C5.3695 4.89279 5.24551 4.79103 5.10044 4.73095C4.95538 4.67086 4.79576 4.65514 4.64176 4.68577C4.48776 4.71641 4.34629 4.792 4.23526 4.90303C4.12423 5.01406 4.04864 5.15553 4.018 5.30953C3.98737 5.46353 4.00309 5.62315 4.06318 5.76821C4.12326 5.91328 4.22502 6.03726 4.35558 6.1245C4.48614 6.21173 4.63962 6.25829 4.79663 6.25829C5.00704 6.2578 5.20869 6.17402 5.35747 6.02524C5.50625 5.87646 5.59006 5.67481 5.59055 5.4644Z"
													fill="white"
												/>
											</svg>
											<svg
												width={4}
												height={3}
												viewBox="0 0 4 3"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute cursor-pointer left-[21.42px] top-[19.83px]"
												preserveAspectRatio="none"
											>
												<path
													d="M2.23636 0.333496C2.49592 0.333496 2.74965 0.410458 2.96546 0.55466C3.18127 0.698862 3.34947 0.903829 3.4488 1.14363C3.54813 1.38343 3.57413 1.6473 3.52349 1.90187C3.47286 2.15644 3.34786 2.39027 3.16432 2.57381C2.98079 2.75734 2.74694 2.88233 2.49237 2.93296C2.2378 2.9836 1.97394 2.95761 1.73414 2.85829C1.49434 2.75896 1.28938 2.59075 1.14518 2.37493C1.00097 2.15912 0.924011 1.90539 0.924011 1.64583C0.924746 1.298 1.06324 0.964632 1.30919 0.718679C1.55515 0.472726 1.88853 0.334231 2.23636 0.333496Z"
													fill="white"
												/>
											</svg>
											<svg
												width={5}
												height={4}
												viewBox="0 0 5 4"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute cursor-pointer left-[17.39px] top-[17.6px]"
												preserveAspectRatio="none"
											>
												<path
													d="M2.70743 0.0993805C3.06618 0.0999309 3.41672 0.206836 3.71472 0.406587C4.01272 0.606339 4.24482 0.889964 4.38164 1.2216C4.51846 1.55324 4.55388 1.918 4.48342 2.26977C4.41296 2.62153 4.23976 2.94452 3.98576 3.19787C3.73176 3.45122 3.40836 3.62358 3.05641 3.69314C2.70446 3.7627 2.33979 3.72634 2.0085 3.58867C1.67721 3.451 1.39419 3.2182 1.1952 2.91969C0.996208 2.62118 0.8902 2.27037 0.890566 1.91161C0.890197 1.67313 0.936973 1.43693 1.02821 1.21659C1.11944 0.996252 1.25332 0.796125 1.42216 0.627709C1.59101 0.459293 1.79149 0.325907 2.01207 0.235238C2.23264 0.144568 2.46895 0.0984023 2.70743 0.0993805Z"
													fill="white"
												/>
											</svg>
											<svg
												width={3}
												height={3}
												viewBox="0 0 3 3"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute cursor-pointer left-[16.72px] top-[14.95px]"
												preserveAspectRatio="none"
											>
												<path
													d="M1.24203 0.449972C1.44563 0.449423 1.64484 0.509261 1.81444 0.621923C1.98404 0.734585 2.11641 0.895011 2.19484 1.08291C2.27326 1.27081 2.29422 1.47775 2.25504 1.67755C2.21586 1.87736 2.1183 2.06105 1.97472 2.20542C1.83114 2.34978 1.64798 2.44832 1.44839 2.48858C1.2488 2.52885 1.04174 2.50902 0.853418 2.43161C0.665097 2.3542 0.503977 2.22268 0.3904 2.05369C0.276823 1.88471 0.215894 1.68583 0.215342 1.48222C0.213738 1.34669 0.239162 1.2122 0.29012 1.0866C0.341079 0.960998 0.41655 0.846814 0.512133 0.750712C0.607717 0.65461 0.721501 0.578523 0.846823 0.526887C0.972145 0.475251 1.10649 0.4491 1.24203 0.449972Z"
													fill="white"
												/>
											</svg>
											<svg
												width={3}
												height={3}
												viewBox="0 0 3 3"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute cursor-pointer left-[15.95px] top-[21.23px]"
												preserveAspectRatio="none"
											>
												<path
													d="M1.23855 0.73218C1.39466 0.73218 1.54724 0.778467 1.67703 0.865192C1.80683 0.951917 1.908 1.07519 1.96774 1.21941C2.02748 1.36363 2.04311 1.52232 2.01266 1.67542C1.9822 1.82853 1.90702 1.96915 1.79664 2.07953C1.68626 2.18991 1.54563 2.26509 1.39253 2.29554C1.23942 2.32599 1.08072 2.31036 0.936499 2.25062C0.792281 2.19089 0.669034 2.08972 0.582309 1.95993C0.495584 1.83014 0.449282 1.67754 0.449282 1.52144C0.449037 1.41772 0.469284 1.31498 0.508861 1.21911C0.548438 1.12325 0.606561 1.03615 0.679899 0.962811C0.753238 0.889473 0.840348 0.831336 0.936216 0.791759C1.03208 0.752181 1.13484 0.731935 1.23855 0.73218Z"
													fill="white"
												/>
											</svg>
											<svg
												width={3}
												height={3}
												viewBox="0 0 3 3"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute cursor-pointer left-[14.65px] top-[12.88px]"
												preserveAspectRatio="none"
											>
												<path
													d="M1.19704 0.382569C1.40342 0.382936 1.60507 0.444448 1.77652 0.559339C1.94797 0.67423 2.08153 0.837348 2.16035 1.02809C2.23916 1.21884 2.25968 1.42866 2.21933 1.63107C2.17898 1.83347 2.07954 2.01938 1.93361 2.16532C1.78767 2.31125 1.60178 2.41067 1.39938 2.45103C1.19697 2.49138 0.987145 2.47086 0.796398 2.39205C0.605652 2.31324 0.442526 2.17968 0.327635 2.00823C0.212744 1.83677 0.151246 1.63512 0.150879 1.42873C0.150757 1.29131 0.177739 1.15523 0.230271 1.02824C0.282802 0.901262 0.359841 0.785884 0.45701 0.688714C0.55418 0.591544 0.669558 0.514485 0.79654 0.461953C0.923521 0.409422 1.05962 0.382447 1.19704 0.382569Z"
													fill="white"
												/>
											</svg>
											<svg
												width={9}
												height={10}
												viewBox="0 0 9 10"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute cursor-pointer left-[8.39px] top-[14.84px]"
												preserveAspectRatio="none"
											>
												<path
													d="M8.74885 4.26244C8.74928 5.2611 8.36945 6.22245 7.68658 6.95115C7.0037 7.67985 6.06901 8.12121 5.07243 8.18556L3.88344 9.62218L3.62653 8.0149C2.93475 7.79503 2.31736 7.38793 1.84274 6.83871C1.36813 6.28949 1.05483 5.6196 0.937567 4.90325C0.820303 4.18691 0.90365 3.45208 1.17837 2.7802C1.4531 2.10831 1.90847 1.52561 2.49404 1.09664C3.0796 0.667668 3.7725 0.409184 4.49595 0.349835C5.2194 0.290485 5.94515 0.432584 6.5928 0.760385C7.24045 1.08818 7.78469 1.58889 8.16525 2.20701C8.5458 2.82514 8.7478 3.53656 8.74885 4.26244ZM6.71773 4.26244C6.71773 4.1665 6.68928 4.07272 6.63598 3.99295C6.58268 3.91319 6.50693 3.85102 6.41829 3.81431C6.32966 3.7776 6.23214 3.76799 6.13805 3.78671C6.04395 3.80542 5.95752 3.85161 5.88968 3.91945C5.82185 3.98729 5.77566 4.07372 5.75694 4.16781C5.73822 4.26191 5.74782 4.35943 5.78454 4.44806C5.82125 4.53669 5.88342 4.61245 5.96319 4.66575C6.04295 4.71905 6.13673 4.7475 6.23267 4.7475C6.2964 4.74762 6.35953 4.73516 6.41844 4.71082C6.47734 4.68649 6.53086 4.65076 6.57593 4.6057C6.621 4.56063 6.65672 4.50711 6.68105 4.44821C6.70538 4.3893 6.71785 4.32617 6.71773 4.26244ZM5.30059 4.26244C5.30059 4.1665 5.27213 4.07272 5.21883 3.99295C5.16553 3.91319 5.08978 3.85102 5.00115 3.81431C4.91252 3.7776 4.81499 3.76799 4.7209 3.78671C4.62681 3.80542 4.54037 3.85161 4.47254 3.91945C4.4047 3.98729 4.35851 4.07372 4.33979 4.16781C4.32108 4.26191 4.33068 4.35943 4.36739 4.44806C4.4041 4.53669 4.46628 4.61245 4.54604 4.66575C4.62581 4.71905 4.71959 4.7475 4.81552 4.7475C4.87925 4.74762 4.94239 4.73516 5.00129 4.71082C5.0602 4.68649 5.11372 4.65076 5.15879 4.6057C5.20385 4.56063 5.23957 4.50711 5.26391 4.44821C5.28824 4.3893 5.30071 4.32617 5.30059 4.26244ZM3.88344 4.26244C3.88344 4.1665 3.85499 4.07272 3.80169 3.99295C3.74839 3.91319 3.67264 3.85102 3.58401 3.81431C3.49537 3.7776 3.39785 3.76799 3.30376 3.78671C3.20967 3.80542 3.12323 3.85161 3.05539 3.91945C2.98756 3.98729 2.94137 4.07372 2.92265 4.16781C2.90393 4.26191 2.91353 4.35943 2.95025 4.44806C2.98696 4.53669 3.04913 4.61245 3.1289 4.66575C3.20867 4.71905 3.30244 4.7475 3.39838 4.7475C3.46211 4.74762 3.52524 4.73516 3.58415 4.71082C3.64305 4.68649 3.69658 4.65076 3.74164 4.6057C3.78671 4.56063 3.82243 4.50711 3.84676 4.44821C3.87109 4.3893 3.88356 4.32617 3.88344 4.26244Z"
													fill="white"
												/>
											</svg>
											<svg
												width={3}
												height={3}
												viewBox="0 0 3 3"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute cursor-pointer left-[13.09px] top-[23.52px]"
												preserveAspectRatio="none"
											>
												<path
													d="M1.71867 0.0246582C1.94154 0.0246582 2.15941 0.0907549 2.34472 0.214575C2.53003 0.338395 2.67445 0.514369 2.75974 0.720275C2.84502 0.92618 2.86735 1.15275 2.82387 1.37134C2.78039 1.58993 2.67307 1.79072 2.51548 1.94831C2.35788 2.1059 2.1571 2.21322 1.93851 2.2567C1.71992 2.30018 1.49335 2.27789 1.28744 2.1926C1.08154 2.10731 0.905534 1.96286 0.781714 1.77755C0.657894 1.59224 0.591797 1.37438 0.591797 1.15151C0.591797 0.852648 0.710519 0.566032 0.921845 0.354706C1.13317 0.14338 1.41981 0.0246582 1.71867 0.0246582Z"
													fill="white"
												/>
											</svg>
											<svg
												width={3}
												height={3}
												viewBox="0 0 3 3"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute cursor-pointer left-[10.72px] top-[12.93px]"
												preserveAspectRatio="none"
											>
												<path
													d="M2.68337 2.01632C3.08476 1.53737 3.0219 0.823716 2.54296 0.422319C2.06401 0.0209222 1.35036 0.0837857 0.948961 0.562729C0.547564 1.04167 0.610428 1.75533 1.08937 2.15672C1.56831 2.55812 2.28197 2.49526 2.68337 2.01632Z"
													fill="white"
												/>
											</svg>
											<svg
												width={7}
												height={8}
												viewBox="0 0 7 8"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute cursor-pointer left-[7.77px] top-[25.41px]"
												preserveAspectRatio="none"
											>
												<path
													d="M3.34181 0.912598C2.73432 0.912598 2.14046 1.09273 1.63534 1.43021C1.13022 1.7677 0.736512 2.24737 0.503994 2.8086C0.271476 3.36982 0.210588 3.9874 0.329035 4.58323C0.447483 5.17906 0.739944 5.72638 1.16944 6.156C1.59893 6.58562 2.14618 6.87827 2.74197 6.9969C3.33776 7.11553 3.95536 7.05481 4.51666 6.82246C5.07796 6.59011 5.55776 6.19656 5.8954 5.69154C6.23303 5.18652 6.41334 4.59272 6.41352 3.98523C6.41229 3.17085 6.0883 2.39018 5.51253 1.81424C4.93677 1.2383 4.15619 0.914069 3.34181 0.912598ZM4.85912 4.14662L2.65734 5.41629C2.61497 5.44063 2.56471 5.44727 2.51748 5.43477C2.47025 5.42227 2.42985 5.39163 2.40507 5.34952C2.39022 5.32079 2.38198 5.28909 2.38096 5.25677V2.71276C2.38096 2.66356 2.4005 2.61639 2.43529 2.5816C2.47007 2.54682 2.51726 2.52729 2.56646 2.52729C2.59889 2.52755 2.63074 2.53584 2.6592 2.5514L4.86097 3.82107C4.88245 3.83334 4.90124 3.8498 4.91626 3.86944C4.93129 3.88909 4.94224 3.91154 4.94846 3.93547C4.95468 3.95941 4.95606 3.98433 4.95251 4.00881C4.94895 4.03328 4.94052 4.05681 4.92774 4.07798C4.91377 4.10831 4.88944 4.13265 4.85912 4.14662Z"
													fill="white"
												/>
											</svg>
											<svg
												width={5}
												height={5}
												viewBox="0 0 5 5"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute cursor-pointer left-[5.74px] top-[10.82px]"
												preserveAspectRatio="none"
											>
												<path
													d="M2.47411 0.321533C2.9154 0.322084 3.34661 0.453407 3.7133 0.698915C4.07998 0.944423 4.36568 1.2931 4.5343 1.7009C4.70292 2.1087 4.7469 2.55732 4.66067 2.9901C4.57445 3.42288 4.36189 3.8204 4.04986 4.13243C3.73782 4.44447 3.3403 4.65702 2.90752 4.74325C2.47475 4.82947 2.02613 4.7855 1.61833 4.61688C1.21053 4.44827 0.861846 4.16257 0.616338 3.79588C0.37083 3.4292 0.239503 2.99797 0.238953 2.55669C0.238831 2.26313 0.296561 1.97242 0.408845 1.70119C0.521129 1.42995 0.685767 1.1835 0.893345 0.975924C1.10092 0.768346 1.34737 0.603711 1.61861 0.491427C1.88985 0.379143 2.18055 0.321412 2.47411 0.321533ZM3.65383 2.6754C3.6698 2.66579 3.68371 2.65311 3.69475 2.63809C3.70578 2.62307 3.71372 2.60601 3.71812 2.58789C3.72252 2.56978 3.72328 2.55097 3.72036 2.53256C3.71744 2.51415 3.71091 2.49651 3.70113 2.48064C3.68909 2.46154 3.67293 2.44538 3.65383 2.43334L1.90837 1.4252C1.89279 1.41578 1.87551 1.40952 1.85751 1.4068C1.8395 1.40408 1.82114 1.40494 1.80347 1.40933C1.78581 1.41373 1.76918 1.42157 1.75455 1.43241C1.73992 1.44325 1.72758 1.45688 1.71824 1.4725C1.70519 1.49401 1.69845 1.51876 1.69876 1.54391V3.55556C1.69942 3.59244 1.71406 3.6277 1.73971 3.65421C1.76536 3.68072 1.80012 3.69651 1.83696 3.69838C1.86211 3.6987 1.88685 3.69195 1.90837 3.67891L3.65383 2.6754Z"
													fill="white"
												/>
											</svg>
											<svg
												width={5}
												height={5}
												viewBox="0 0 5 5"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute cursor-pointer left-[5px] top-[30.84px]"
												preserveAspectRatio="none"
											>
												<path
													d="M2.48918 0.34375C2.88228 0.34375 3.26654 0.46033 3.59339 0.678723C3.92023 0.897115 4.17498 1.20751 4.32541 1.57068C4.47585 1.93385 4.5152 2.3335 4.43852 2.71904C4.36183 3.10458 4.17253 3.45873 3.89457 3.73669C3.61661 4.01466 3.26247 4.20394 2.87692 4.28063C2.49138 4.35732 2.09176 4.31796 1.72859 4.16753C1.36541 4.0171 1.055 3.76234 0.836606 3.43549C0.618214 3.10864 0.501648 2.72438 0.501648 2.33128C0.503116 1.80461 0.712993 1.29993 1.08541 0.927511C1.45782 0.555095 1.96251 0.345218 2.48918 0.34375Z"
													fill="white"
												/>
											</svg>
											<svg
												width={2}
												height={2}
												viewBox="0 0 2 2"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute cursor-pointer left-[6.79px] top-[15.78px]"
												preserveAspectRatio="none"
											>
												<path
													d="M1.07442 1.8422C1.50519 1.8422 1.85441 1.49299 1.85441 1.06221C1.85441 0.631438 1.50519 0.282227 1.07442 0.282227C0.643645 0.282227 0.294434 0.631438 0.294434 1.06221C0.294434 1.49299 0.643645 1.8422 1.07442 1.8422Z"
													fill="white"
												/>
											</svg>
											<svg
												width={3}
												height={2}
												viewBox="0 0 3 2"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute cursor-pointer left-[6.44px] top-[28.88px]"
												preserveAspectRatio="none"
											>
												<path
													d="M1.49013 1.47769C1.79234 1.47769 2.03732 1.2327 2.03732 0.930497C2.03732 0.628289 1.79234 0.383301 1.49013 0.383301C1.18792 0.383301 0.942932 0.628289 0.942932 0.930497C0.942932 1.2327 1.18792 1.47769 1.49013 1.47769Z"
													fill="white"
												/>
											</svg>
											<svg
												width={5}
												height={4}
												viewBox="0 0 5 4"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute left-[3.33px] top-[24.51px]"
												preserveAspectRatio="none"
											>
												<path
													d="M2.81974 0.00805858C3.21339 0.00750867 3.59836 0.123687 3.92597 0.341927C4.25358 0.560168 4.50912 0.87067 4.66027 1.23414C4.81142 1.59761 4.85139 1.99773 4.77514 2.38392C4.69888 2.7701 4.50982 3.12501 4.23186 3.40375C3.9539 3.68249 3.59952 3.87256 3.21355 3.94989C2.82757 4.02723 2.42734 3.98837 2.06345 3.83824C1.69955 3.6881 1.38835 3.43342 1.16919 3.10642C0.950039 2.77942 0.83277 2.39478 0.83222 2.00114C0.83161 1.7397 0.882567 1.48071 0.982165 1.23898C1.08176 0.997255 1.22805 0.777538 1.41265 0.592414C1.59726 0.407289 1.81656 0.260407 2.05801 0.160134C2.29946 0.05986 2.5583 0.00817981 2.81974 0.00805858Z"
													fill="white"
												/>
											</svg>
											<svg
												width={4}
												height={4}
												viewBox="0 0 4 4"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute left-[3.79px] top-[35.22px]"
												preserveAspectRatio="none"
											>
												<path
													d="M1.93011 0.719251C2.2546 0.719251 2.5718 0.815499 2.84161 0.995777C3.11141 1.17605 3.3217 1.43227 3.44587 1.73207C3.57005 2.03186 3.60255 2.36175 3.53924 2.68001C3.47594 2.99827 3.31968 3.29061 3.09023 3.52006C2.86078 3.74951 2.56844 3.90576 2.25018 3.96906C1.93193 4.03237 1.60204 3.9999 1.30225 3.87572C1.00246 3.75154 0.746224 3.54124 0.565946 3.27144C0.385668 3.00163 0.289442 2.68439 0.289442 2.35989C0.288583 2.1442 0.330437 1.93049 0.412583 1.73105C0.49473 1.5316 0.615548 1.35038 0.768069 1.19786C0.920589 1.04534 1.1018 0.924575 1.30124 0.842428C1.50068 0.760281 1.71441 0.718393 1.93011 0.719251Z"
													fill="white"
												/>
											</svg>
											<svg
												width={2}
												height={2}
												viewBox="0 0 2 2"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute left-[5.1px] top-[9.5px]"
												preserveAspectRatio="none"
											>
												<path
													d="M1.30574 2.45705e-06C1.44496 2.45705e-06 1.58106 0.0412875 1.69682 0.118637C1.81259 0.195986 1.90281 0.305926 1.95609 0.434553C2.00937 0.563181 2.02331 0.704718 1.99615 0.841268C1.96899 0.977818 1.90195 1.10325 1.8035 1.20169C1.70505 1.30014 1.57963 1.36719 1.44308 1.39435C1.30653 1.42151 1.16499 1.40757 1.03636 1.35429C0.907733 1.30101 0.797793 1.21078 0.720443 1.09502C0.643094 0.979261 0.601809 0.843163 0.601809 0.703938C0.601564 0.611427 0.619603 0.51978 0.654892 0.434264C0.690182 0.348748 0.742026 0.27105 0.807441 0.205635C0.872857 0.140219 0.950555 0.0883772 1.03607 0.0530878C1.12159 0.0177985 1.21323 -0.000242282 1.30574 2.45705e-06Z"
													fill="white"
												/>
											</svg>
											<svg
												width={3}
												height={3}
												viewBox="0 0 3 3"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute left-[3.19px] top-[28.88px]"
												preserveAspectRatio="none"
											>
												<path
													d="M1.75595 2.51458C2.34449 2.51458 2.82159 2.03748 2.82159 1.44894C2.82159 0.860404 2.34449 0.383301 1.75595 0.383301C1.16741 0.383301 0.690308 0.860404 0.690308 1.44894C0.690308 2.03748 1.16741 2.51458 1.75595 2.51458Z"
													fill="white"
												/>
											</svg>
											<svg
												width={4}
												height={4}
												viewBox="0 0 4 4"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute left-[1.14px] top-[32.1px]"
												preserveAspectRatio="none"
											>
												<path
													d="M2.27671 0.604005C2.60061 0.603639 2.91735 0.699319 3.18688 0.878946C3.45642 1.05857 3.66663 1.31408 3.79097 1.61317C3.9153 1.91226 3.94816 2.24151 3.8854 2.55927C3.82264 2.87703 3.66707 3.16906 3.43836 3.39841C3.20965 3.62777 2.91807 3.78416 2.60049 3.84782C2.2829 3.91148 1.95357 3.87954 1.65413 3.75606C1.3547 3.63257 1.09859 3.42309 0.918203 3.15407C0.737814 2.88505 0.641241 2.56858 0.64069 2.24468C0.640202 2.02948 0.682152 1.8163 0.76414 1.61733C0.846128 1.41836 0.966545 1.23749 1.1185 1.08511C1.27046 0.932723 1.45097 0.811799 1.6497 0.729248C1.84844 0.646697 2.06151 0.604126 2.27671 0.604005Z"
													fill="white"
												/>
											</svg>
											<svg
												width={4}
												height={4}
												viewBox="0 0 4 4"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute left-[0.74px] top-[21.23px]"
												preserveAspectRatio="none"
											>
												<path
													d="M1.88163 0.732191C2.20553 0.732741 2.522 0.829318 2.79102 1.00971C3.06004 1.1901 3.26953 1.4462 3.39302 1.74564C3.51651 2.04508 3.54844 2.3744 3.48477 2.69198C3.42111 3.00957 3.26472 3.30115 3.03536 3.52986C2.806 3.75856 2.51398 3.91415 2.19622 3.97691C1.87846 4.03967 1.54922 4.00681 1.25013 3.88247C0.951041 3.75814 0.695531 3.54792 0.515905 3.27839C0.336279 3.00886 0.240602 2.69212 0.240968 2.36822C0.240722 2.15292 0.283024 1.93968 0.365445 1.74077C0.447866 1.54187 0.568781 1.3612 0.72124 1.20918C0.873699 1.05715 1.0547 0.936758 1.25384 0.854901C1.45297 0.773043 1.66632 0.731335 1.88163 0.732191Z"
													fill="white"
												/>
											</svg>
											<svg
												width={4}
												height={4}
												viewBox="0 0 4 4"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute left-[-0.41px] top-[24.92px]"
												preserveAspectRatio="none"
											>
												<path
													d="M1.73527 0.418701C2.05917 0.419252 2.37563 0.515801 2.64465 0.696189C2.91368 0.876578 3.12317 1.1327 3.24666 1.43214C3.37014 1.73158 3.40207 2.06091 3.33841 2.3785C3.27475 2.69608 3.11835 2.98766 2.889 3.21637C2.65964 3.44507 2.36762 3.60063 2.04986 3.66339C1.73209 3.72616 1.40286 3.6933 1.10377 3.56897C0.804679 3.44464 0.54917 3.23442 0.369544 2.96489C0.189917 2.69536 0.0942392 2.37861 0.0946055 2.0547C0.0955883 1.6203 0.268906 1.20405 0.57651 0.897314C0.884114 0.59058 1.30086 0.418455 1.73527 0.418701Z"
													fill="white"
												/>
											</svg>
											<svg
												width={4}
												height={4}
												viewBox="0 0 4 4"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute cursor-pointer left-[-0.5px] top-[28.61px]"
												preserveAspectRatio="none"
											>
												<path
													d="M1.64067 0.108159C1.85582 0.108463 2.06881 0.151154 2.26746 0.23377C2.46612 0.316385 2.64656 0.437309 2.79848 0.589658C2.9504 0.742008 3.07082 0.922791 3.15287 1.12168C3.23493 1.32057 3.277 1.53368 3.2767 1.74883C3.27639 1.96398 3.23371 2.17696 3.1511 2.37561C3.06848 2.57427 2.94755 2.75472 2.7952 2.90664C2.64285 3.05856 2.46207 3.17898 2.26318 3.26103C2.06429 3.34309 1.85119 3.38516 1.63604 3.38486C1.42073 3.38511 1.2075 3.3428 1.00859 3.26038C0.809688 3.17796 0.629031 3.05704 0.477003 2.90458C0.324974 2.75212 0.204572 2.57113 0.122714 2.37199C0.0408566 2.17285 -0.000842596 1.95949 1.29013e-05 1.74419C0.000134276 1.52899 0.0426878 1.31592 0.125239 1.11718C0.20779 0.918441 0.328718 0.737934 0.481104 0.585979C0.63349 0.434024 0.814342 0.313607 1.01331 0.231619C1.21229 0.149631 1.42547 0.107671 1.64067 0.108159Z"
													fill="white"
												/>
											</svg>
											<svg
												width={8}
												height={5}
												viewBox="0 0 8 5"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="absolute cursor-pointer left-[28.02px] top-[15.52px]"
												preserveAspectRatio="none"
											>
												<path
													d="M4.02859 3.49708L3.84773 3.86341L4.71308 3.83467L7.40916 3.75398L5.18326 1.95657C5.08781 1.42814 4.81429 0.94834 4.40819 0.597006C4.0021 0.245672 3.48791 0.0440006 2.95124 0.0255573C2.41457 0.0071141 1.88777 0.173011 1.45851 0.495637C1.02925 0.818263 0.723416 1.27816 0.591912 1.7988C0.460409 2.31943 0.511186 2.86939 0.735751 3.35716C0.960316 3.84493 1.34518 4.24109 1.82623 4.47971C2.30728 4.71833 2.85553 4.78501 3.37976 4.66866C3.90398 4.55231 4.37253 4.25995 4.70747 3.84023L3.84218 3.86897L4.02859 3.49708ZM1.91216 2.70318C1.82447 2.70379 1.74013 2.66955 1.67769 2.60798C1.61525 2.54641 1.57981 2.46255 1.5792 2.37486C1.57858 2.28717 1.61284 2.20282 1.67441 2.14038C1.73598 2.07794 1.81983 2.04252 1.90752 2.04191C1.95074 2.04154 1.99358 2.04977 2.03358 2.06614C2.07358 2.08251 2.10995 2.10667 2.14051 2.13724C2.17107 2.1678 2.19524 2.20414 2.21161 2.24414C2.22798 2.28414 2.23621 2.327 2.23584 2.37022C2.23801 2.41365 2.23123 2.45707 2.21591 2.49777C2.20059 2.53847 2.17706 2.57559 2.1468 2.60682C2.11653 2.63805 2.08013 2.6627 2.03992 2.67928C1.99972 2.69585 1.95564 2.704 1.91216 2.70318ZM2.85818 2.70318C2.79324 2.70318 2.72972 2.68392 2.67573 2.64785C2.62174 2.61177 2.57967 2.56049 2.55482 2.5005C2.52997 2.44051 2.52347 2.37449 2.53614 2.31081C2.54881 2.24712 2.58006 2.18861 2.62598 2.1427C2.67189 2.09678 2.73041 2.06552 2.7941 2.05285C2.85779 2.04018 2.9238 2.04668 2.98379 2.07153C3.04378 2.09638 3.09506 2.13846 3.13114 2.19246C3.16721 2.24645 3.18644 2.30992 3.18644 2.37486C3.18719 2.4181 3.1793 2.46105 3.16312 2.50116C3.14694 2.54127 3.12284 2.57772 3.0923 2.60835C3.06177 2.63897 3.02538 2.66316 2.98532 2.67945C2.94525 2.69574 2.90142 2.70381 2.85818 2.70318ZM3.47678 2.37022C3.47678 2.30528 3.49601 2.24181 3.53208 2.18781C3.56816 2.13382 3.61944 2.09175 3.67943 2.0669C3.73943 2.04205 3.80544 2.03554 3.86912 2.04821C3.93281 2.06087 3.99133 2.09215 4.03725 2.13807C4.08316 2.18399 4.11441 2.24248 4.12708 2.30617C4.13975 2.36985 4.13325 2.43586 4.1084 2.49586C4.08355 2.55585 4.04148 2.60713 3.98749 2.6432C3.9335 2.67928 3.87004 2.69854 3.8051 2.69854C3.76178 2.69929 3.7187 2.69132 3.67853 2.67509C3.63835 2.65886 3.6019 2.6347 3.57126 2.60406C3.54062 2.57342 3.51645 2.53692 3.50022 2.49675C3.48398 2.45657 3.47603 2.41354 3.47678 2.37022Z"
													fill="white"
												/>
											</svg>
											<div className="w-[166.75px] h-[29px]">
												<p
													className="w-[46.72px] h-[29px] absolute left-[35.82px] top-2.5 text-[19px] font-bold text-left text-white">
													CLIPSYMPHONY
												</p>
											</div>
										</div>
									</div>
								</div>
								<div className="flex justify-start items-start gap-40">
									<div className="flex flex-col justify-start items-start gap-7">
										<div className="flex flex-col justify-start items-start relative gap-5">
											<p className="text-lg text-left text-white">
												{i18next.t("SCARATEC IT-Consulting GmbH.")}
											</p>
											<p className="text-lg text-left text-white">
												{i18next.t("Martin-Luther-Platz 22")}
											</p>
											<p className="text-lg text-left text-white">
												<span>{i18next.t("40212 Düsseldorf")}</span>
												<br/>
												<span>{i18next.t("Germany")}</span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="flex justify-end items-start gap-5">
								<a href="https://www.linkedin.com/company/clipsymphony" target="_blank">
									<svg
										width={30}
										height={30}
										viewBox="0 0 30 30"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
										className="flex-grow-0 cursor-pointer flex-shrink-0 w-[30px] h-[30px]"
										preserveAspectRatio="xMidYMid meet"
									>
										<circle cx={15} cy={15} r={15} fill="white"/>
										<path d="M8.22154 22.0588H11.3056V12.0745H8.22154V22.0588Z" fill="black"/>
										<path
											d="M7.94116 8.88696C7.94116 9.87134 8.73555 10.6682 9.76359 10.6682C10.7449 10.6682 11.5393 9.87134 11.5393 8.88696C11.5393 7.90259 10.7449 7.05884 9.76359 7.05884C8.73555 7.05884 7.94116 7.90259 7.94116 8.88696Z"
											fill="black"
										/>
										<path
											d="M19.8103 22.0588H22.9412V16.5745C22.9412 13.9026 22.3337 11.7932 19.2028 11.7932C17.7075 11.7932 16.6795 12.637 16.2589 13.4338H16.2122V12.0745H13.2683V22.0588H16.3524V17.137C16.3524 15.8245 16.586 14.5588 18.2215 14.5588C19.8103 14.5588 19.8103 16.0588 19.8103 17.1838V22.0588Z"
											fill="black"
										/>
									</svg>
								</a>
								<a href="https://www.facebook.com/ClipSymphony" target="_blank">
									<svg
										width={30}
										height={30}
										viewBox="0 0 30 30"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
										className="flex-grow-0 cursor-pointer flex-shrink-0"
										preserveAspectRatio="xMidYMid meet"
									>
										<path
											d="M30 15.0913C30 6.75456 23.2863 0 15 0C6.71371 0 0 6.75456 0 15.0913C0 22.6369 5.44355 28.9047 12.6411 30V19.4726H8.83064V15.0913H12.6411V11.8053C12.6411 8.03245 14.879 5.90264 18.2661 5.90264C19.9597 5.90264 21.6532 6.2069 21.6532 6.2069V9.91886H19.7782C17.9032 9.91886 17.2984 11.0751 17.2984 12.2921V15.0913H21.4718L20.8065 19.4726H17.2984V30C24.496 28.9047 30 22.6369 30 15.0913Z"
											fill="white"
										/>
									</svg>
								</a>
								<a href="https://x.com/clipsymphonyInc" target="_blank">
									<img alt="Twitter" className={"w-[30px] h-[30px]"} src="https://storage.googleapis.com/clipsymphony_static_assets/Icons/x_landing_page.svg" title="Twitter"/>
								</a>
							</div>
						</div>
						<div className="flex flex-col justify-start items-start relative gap-12">
							<svg
								width="100%"
								height={1}
								viewBox="0 0 1120 1"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
								className="flex-grow-0 flex-shrink-0"
								preserveAspectRatio="xMidYMid meet"
							>
								<line y1="0.5" x2={1120} y2="0.5" stroke="white"/>
							</svg>
							<div className="flex flex-col md:flex-row justify-start items-start relative gap-10">
								<p className="text-lg text-left text-white">
									{i18next.t("© 2024 Clipsymphony All Rights Reserved")}
								</p>
								<a href="/app/terms-and-conditions" className="text-lg text-left text-white">
									{i18next.t("Terms and Conditions")}
								</a>
								<a href="/app/privacy-policy" className="text-lg text-left text-white">
									{i18next.t("Privacy Policy")}
								</a>
							</div>
						</div>
					</div>
				</div>
				<Cookie/>
				<BackToTopBtn/>
			</Router>
		);
	}
}
